import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.benchmarks.llm');
import { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { Chart, ChartConfiguration, registerables } from 'chart.js';
import { Service } from "src/libs/portal/season/service";
import { BENCHMARK_CATEGORIES, BENCHMARK_CATEGORY_GUIDES, BENCHMARK_TOC_ITEMS, BenchmarkCategoryGuide, BenchmarkDetail } from '../benchmark-catalog';

Chart.register(...registerables);

interface BenchmarkModel {
    id: string;
    name: string;
    color: string;
}

interface BenchmarkScoreSet {
    id: string;
    name: string;
    category: string;
    description: string;
    unit: string;
    scores: Record<string, number>;
}

type BenchmarkCategoryGuideCard = BenchmarkCategoryGuide & {
    count: number;
    featuredItems: BenchmarkDetail[];
};

const BENCHMARK_MODELS: BenchmarkModel[] = [
    { id: 'gpt-55', name: 'GPT-5.5', color: '#8bdba7' },
    { id: 'claude-opus-47', name: 'Claude Opus 4.7', color: '#9ec5ff' },
    { id: 'gemini-35-flash', name: 'Gemini 3.5 Flash', color: '#a7f3d0' },
    { id: 'gemini-31-pro', name: 'Gemini 3.1 Pro', color: '#c4b5fd' },
    { id: 'deepseek-v4-pro-max', name: 'DeepSeek V4-Pro Max', color: '#fdba8c' },
    { id: 'kimi-k26', name: 'Kimi K2.6', color: '#f9a8c5' },
    { id: 'gpt-55-pro', name: 'GPT-5.5 Pro', color: '#67e8d4' },
    { id: 'qwen3-max', name: 'Qwen3 Max', color: '#fde68a' },
    { id: 'mistral-large-32', name: 'Mistral Large 3.2', color: '#f0abfc' },
    { id: 'grok-41', name: 'Grok 4.1', color: '#bae6fd' },
];

const BENCHMARK_SCORE_SETS: BenchmarkScoreSet[] = [
    {
        id: 'swe-bench-pro',
        name: 'SWE-bench Pro',
        category: '소프트웨어 이슈 해결',
        description: '실제 저장소 이슈 해결 능력을 비교하는 코딩 에이전트 지표입니다.',
        unit: '%',
        scores: {
            'claude-opus-47': 64.3,
            'gpt-55': 58.6,
            'kimi-k26': 58.6,
            'deepseek-v4-pro-max': 55.4,
            'gemini-35-flash': 55.1,
            'gemini-31-pro': 54.2,
            'gpt-55-pro': 63.8,
            'qwen3-max': 52.1,
            'mistral-large-32': 49.6,
            'grok-41': 57.2,
        },
    },
    {
        id: 'terminal-bench-2',
        name: 'Terminal-Bench 2.0',
        category: '터미널 작업 완수',
        description: '샌드박스 터미널에서 파일, 셸, 테스트를 다루는 작업 성공률입니다.',
        unit: '%',
        scores: {
            'gemini-35-flash': 76.2,
            'gpt-55': 82.7,
            'claude-opus-47': 69.4,
            'gemini-31-pro': 68.5,
            'deepseek-v4-pro-max': 67.9,
            'kimi-k26': 66.7,
            'gpt-55-pro': 84.8,
            'qwen3-max': 65.8,
            'mistral-large-32': 62.9,
            'grok-41': 70.3,
        },
    },
    {
        id: 'browsecomp',
        name: 'BrowseComp',
        category: '어려운 웹 탐색',
        description: '웹에서 찾기 어려운 단답 정보를 탐색해 찾아내는 browsing 지표입니다.',
        unit: '%',
        scores: {
            'gpt-55-pro': 90.1,
            'gemini-31-pro': 85.9,
            'gpt-55': 84.4,
            'deepseek-v4-pro-max': 83.4,
            'kimi-k26': 83.2,
            'claude-opus-47': 82.5,
            'qwen3-max': 78.6,
            'mistral-large-32': 76.4,
            'grok-41': 84.9,
        },
    },
    {
        id: 'gpqa-diamond',
        name: 'GPQA Diamond',
        category: '과학 추론',
        description: '전문 과학 질의에서 깊은 지식과 다단계 추론 안정성을 보는 지표입니다.',
        unit: '%',
        scores: {
            'gpt-55-pro': 88.0,
            'gpt-55': 85.2,
            'claude-opus-47': 84.6,
            'gemini-31-pro': 83.8,
            'deepseek-v4-pro-max': 80.7,
            'kimi-k26': 78.4,
            'qwen3-max': 77.2,
            'mistral-large-32': 73.5,
            'grok-41': 82.1,
        },
    },
    {
        id: 'mmlu-pro',
        name: 'MMLU-Pro',
        category: '범용 지식 추론',
        description: 'MMLU보다 어려운 다지선다 지식/추론 문제로 상위 모델 간 차이를 비교합니다.',
        unit: '%',
        scores: {
            'gpt-55-pro': 91.4,
            'gpt-55': 89.7,
            'gemini-31-pro': 88.9,
            'claude-opus-47': 88.3,
            'deepseek-v4-pro-max': 86.2,
            'qwen3-max': 84.8,
            'kimi-k26': 84.1,
            'grok-41': 86.9,
            'mistral-large-32': 82.3,
        },
    },
    {
        id: 'aime',
        name: 'AIME',
        category: '수학 추론',
        description: '경시 수학 문제를 통해 계산형 추론과 정답 안정성을 비교하는 지표입니다.',
        unit: '%',
        scores: {
            'gpt-55-pro': 96.2,
            'gpt-55': 93.5,
            'claude-opus-47': 91.0,
            'gemini-31-pro': 90.4,
            'deepseek-v4-pro-max': 92.1,
            'qwen3-max': 88.7,
            'kimi-k26': 86.9,
            'grok-41': 89.5,
            'mistral-large-32': 80.1,
        },
    },
    {
        id: 'livecodebench',
        name: 'LiveCodeBench',
        category: '코딩 문제 해결',
        description: '신규 코딩 문제로 오염을 줄이고 코드 생성/수정/실행 능력을 비교합니다.',
        unit: '%',
        scores: {
            'gpt-55-pro': 75.2,
            'claude-opus-47': 73.8,
            'gpt-55': 72.4,
            'deepseek-v4-pro-max': 70.6,
            'qwen3-max': 68.8,
            'kimi-k26': 68.1,
            'gemini-31-pro': 67.5,
            'grok-41': 66.2,
            'mistral-large-32': 61.7,
        },
    },
    {
        id: 'gaia',
        name: 'GAIA',
        category: '일반 에이전트',
        description: '추론, 웹 탐색, 멀티모달, 도구 사용이 결합된 assistant task 지표입니다.',
        unit: '%',
        scores: {
            'gpt-55-pro': 74.4,
            'gpt-55': 70.1,
            'claude-opus-47': 69.7,
            'gemini-31-pro': 67.9,
            'deepseek-v4-pro-max': 63.4,
            'kimi-k26': 62.8,
            'grok-41': 65.2,
            'qwen3-max': 59.4,
            'mistral-large-32': 57.6,
        },
    },
    {
        id: 'mmmu-pro',
        name: 'MMMU-Pro',
        category: '멀티모달 추론',
        description: '이미지와 전문 지식을 함께 읽는 고난도 멀티모달 추론 비교 지표입니다.',
        unit: '%',
        scores: {
            'gemini-35-flash': 83.6,
            'gemini-31-pro': 79.8,
            'gpt-55-pro': 78.9,
            'gpt-55': 76.4,
            'claude-opus-47': 75.7,
            'grok-41': 73.8,
            'qwen3-max': 71.2,
            'deepseek-v4-pro-max': 70.6,
            'kimi-k26': 68.4,
            'mistral-large-32': 66.5,
        },
    },
    {
        id: 'bfcl',
        name: 'BFCL',
        category: '함수 호출',
        description: 'API와 함수 호출을 계획하고 구조화된 호출로 변환하는 능력을 비교합니다.',
        unit: '%',
        scores: {
            'gpt-55-pro': 92.5,
            'gpt-55': 90.3,
            'claude-opus-47': 88.9,
            'gemini-31-pro': 87.1,
            'deepseek-v4-pro-max': 85.8,
            'qwen3-max': 84.9,
            'kimi-k26': 83.7,
            'grok-41': 86.2,
            'mistral-large-32': 81.8,
        },
    },
];

const DEFAULT_BENCHMARK_IDS = BENCHMARK_SCORE_SETS.map((benchmark) => benchmark.id);
const DEFAULT_MODEL_IDS = BENCHMARK_MODELS.map((model) => model.id);

@Component({
    selector: 'wiz-page-benchmarks-llm',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.benchmarks.llm/view.scss */
:host {
  display: block;
  min-height: 100vh;
  color: #202733;
  background: #f3f5f8;
  font-family: Inter, "Spoqa Han Sans Neo", "Apple SD Gothic Neo", "Noto Sans KR", sans-serif;
  overflow-x: hidden;
}

:host,
:host *,
:host *::before,
:host *::after {
  box-sizing: border-box;
}

.benchmark-shell {
  min-height: 100vh;
  overflow-x: hidden;
}

.benchmark-topbar {
  position: sticky;
  top: 0;
  z-index: 20;
  border-bottom: 1px solid #d9dee7;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(8px);
}

.benchmark-topbar__inner {
  width: min(1240px, 100% - 32px);
  min-height: 58px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.benchmark-brand {
  color: #147a3b;
  font-size: 18px;
  font-weight: 850;
  text-decoration: none;
}

.benchmark-nav {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;
}

.benchmark-nav a {
  padding: 7px 10px;
  border-radius: 6px;
  color: #475467;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
}

.benchmark-nav a:hover,
.benchmark-nav a:focus-visible {
  color: #166534;
  background: #e8f5ed;
  outline: none;
}

.benchmark-page {
  width: min(1240px, 100% - 32px);
  max-width: calc(100% - 32px);
  margin: 0 auto;
  padding: 22px 0 42px;
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
  min-width: 0;
}

.benchmark-toc,
.benchmark-infobox {
  position: sticky;
  top: 80px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
}

.benchmark-toc {
  padding: 14px;
}

.benchmark-topbar__inner,
.benchmark-page,
.benchmark-article,
.benchmark-title,
.benchmark-section,
.benchmark-toc,
.benchmark-infobox {
  min-width: 0;
  max-width: 100%;
}

.benchmark-toc h2,
.benchmark-infobox h2 {
  margin: 0;
  color: #101828;
  font-size: 15px;
}

.benchmark-toc ol {
  margin: 10px 0 0;
  padding-left: 0;
  list-style: none;
  display: grid;
  gap: 6px;
}

.benchmark-toc ol ol {
  margin-top: 5px;
  padding-left: 14px;
  gap: 4px;
}

.benchmark-toc a {
  display: inline-flex;
  color: #475467;
  font-size: 12px;
  line-height: 1.45;
  text-decoration: none;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.benchmark-toc a:hover,
.benchmark-toc a:focus-visible {
  color: #147a3b;
  text-decoration: underline;
  outline: none;
}

.benchmark-article {
  min-width: 0;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
}

.benchmark-title {
  padding: 28px 30px 22px;
  border-bottom: 1px solid #e4e8ef;
}

.benchmark-breadcrumb {
  margin: 0 0 8px;
  color: #147a3b;
  font-size: 12px;
  font-weight: 800;
}

.benchmark-title h1 {
  margin: 0;
  color: #111827;
  font-size: 36px;
  line-height: 1.2;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.benchmark-summary {
  max-width: 780px;
  margin: 14px 0 0;
  color: #475467;
  font-size: 15px;
  line-height: 1.75;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.benchmark-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 16px;
}

.benchmark-badges span {
  min-width: 0;
  padding: 5px 8px;
  border: 1px solid #cfd7e3;
  border-radius: 6px;
  color: #344054;
  background: #f8fafc;
  font-size: 12px;
  font-weight: 750;
  overflow-wrap: anywhere;
}

.benchmark-section {
  padding: 24px 30px;
  border-bottom: 1px solid #e4e8ef;
}

.benchmark-section:last-child {
  border-bottom: 0;
}

#reasoning,
#coding,
#agent-web,
#tool-use,
#multimodal,
#korean-safety {
  display: none;
}

.benchmark-section h2 {
  margin: 0 0 14px;
  padding-bottom: 8px;
  border-bottom: 2px solid #d9dee7;
  color: #111827;
  font-size: 24px;
  line-height: 1.3;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.benchmark-section > h3 {
  margin: 22px 0 10px;
  color: #172033;
  font-size: 18px;
  line-height: 1.4;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.section-number {
  margin-right: 8px;
  color: #147a3b;
  font-weight: 850;
}

.benchmark-section p {
  margin: 0 0 12px;
  color: #344054;
  font-size: 14px;
  line-height: 1.8;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.benchmark-rule-grid,
.benchmark-flow {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.benchmark-rule,
.benchmark-flow__item {
  min-width: 0;
  padding: 14px 16px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #fbfcfe;
}

.benchmark-rule h3,
.benchmark-flow__item h3 {
  margin: 0 0 8px;
  color: #172033;
  font-size: 15px;
  line-height: 1.35;
}

.benchmark-rule p,
.benchmark-flow__item p {
  margin: 0;
  color: #344054;
  font-size: 13px;
  line-height: 1.7;
}

.benchmark-flow__item {
  position: relative;
  padding-top: 46px;
}

.benchmark-flow__step {
  position: absolute;
  top: 14px;
  left: 16px;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background: #147a3b;
  font-size: 12px;
  font-weight: 850;
}

.benchmark-checklist {
  margin: 14px 0 0;
  padding: 12px 16px 12px 34px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  color: #344054;
  background: #ffffff;
  font-size: 14px;
  line-height: 1.8;
}

.chart-toolbar {
  margin: 18px 0 12px;
  padding: 12px 14px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  background: #fbfcfe;
}

.chart-toolbar__copy {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.chart-toolbar__copy span {
  color: #147a3b;
  font-size: 12px;
  font-weight: 850;
}

.chart-toolbar__copy strong {
  color: #172033;
  font-size: 14px;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.chart-filter-button,
.benchmark-modal__actions button,
.modal-close {
  min-height: 36px;
  border: 1px solid #cfd7e3;
  border-radius: 6px;
  color: #172033;
  background: #ffffff;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
}

.chart-filter-button {
  flex: 0 0 auto;
  padding: 0 14px;
  color: #ffffff;
  border-color: #147a3b;
  background: #147a3b;
}

.chart-filter-button:hover,
.chart-filter-button:focus-visible,
.benchmark-modal__actions button:last-child:hover,
.benchmark-modal__actions button:last-child:focus-visible {
  border-color: #166534;
  background: #166534;
  outline: none;
}

.chart-panel {
  height: 520px;
  padding: 16px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #ffffff;
}

.chart-canvas-wrap {
  position: relative;
  width: 100%;
  height: 100%;
}

#benchmark-comparison-chart {
  width: 100% !important;
  height: 100% !important;
}

.chart-empty {
  min-height: 260px;
  display: grid;
  align-content: center;
  justify-items: center;
  gap: 6px;
  text-align: center;
}

.chart-empty strong {
  color: #172033;
  font-size: 15px;
}

.chart-empty p {
  max-width: 420px;
  margin: 0;
  color: #667085;
}

.score-table-wrap {
  margin-top: 12px;
  max-width: 100%;
  overflow-x: visible;
  border: 1px solid #d9dee7;
  border-radius: 8px;
}

.score-table {
  width: 100%;
  min-width: 0;
  table-layout: fixed;
  border-collapse: collapse;
  background: #ffffff;
  font-size: 12px;
}

.score-table th,
.score-table td {
  padding: 10px 12px;
  border-bottom: 1px solid #e4e8ef;
  color: #344054;
  text-align: left;
  vertical-align: top;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.score-table thead th {
  color: #172033;
  background: #f1f5f9;
  font-weight: 850;
  white-space: normal;
}

.score-table tbody th {
  width: 190px;
  color: #172033;
  font-weight: 850;
}

.score-table tbody tr:last-child th,
.score-table tbody tr:last-child td {
  border-bottom: 0;
}

.score-table strong,
.score-table span {
  display: block;
}

.score-table span {
  margin-top: 3px;
  color: #667085;
  font-size: 11px;
  font-weight: 700;
}

.benchmark-modal-shell {
  position: fixed;
  inset: 0;
  z-index: 60;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.46);
}

.benchmark-modal {
  width: min(720px, 100%);
  max-height: min(720px, 100vh - 48px);
  overflow: auto;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.22);
}

.benchmark-modal__head {
  padding: 18px 20px;
  border-bottom: 1px solid #e4e8ef;
  display: flex;
  justify-content: space-between;
  gap: 14px;
}

.benchmark-modal__head span {
  color: #147a3b;
  font-size: 12px;
  font-weight: 850;
}

.benchmark-modal__head h3 {
  margin: 4px 0 0;
  color: #111827;
  font-size: 20px;
  line-height: 1.35;
}

.modal-close {
  flex: 0 0 auto;
  padding: 0 12px;
}

.modal-close:hover,
.modal-close:focus-visible,
.benchmark-modal__actions button:first-child:hover,
.benchmark-modal__actions button:first-child:focus-visible {
  border-color: #92c6a5;
  color: #166534;
  outline: none;
}

.model-picker-panel {
  padding: 16px 20px;
  border-bottom: 1px solid #e4e8ef;
  display: grid;
  gap: 12px;
  background: #ffffff;
}

.model-picker-panel__head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

.model-picker-panel__head span {
  color: #172033;
  font-size: 13px;
  font-weight: 850;
}

.model-picker-panel__head small {
  color: #667085;
  font-size: 12px;
  font-weight: 700;
}

.model-picker-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.model-picker-option {
  min-width: 0;
  min-height: 44px;
  padding: 0 12px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  display: grid;
  grid-template-columns: 18px 12px minmax(0, 1fr);
  align-items: center;
  gap: 9px;
  color: #172033;
  background: #ffffff;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
}

.model-picker-option:hover,
.model-picker-option:focus-within {
  border-color: #92c6a5;
  background: #ffffff;
}

.model-picker-option.is-selected {
  border-color: #147a3b;
  background: #ffffff;
  box-shadow: inset 0 0 0 1px rgba(20, 122, 59, 0.08);
}

.option-checkbox {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: #147a3b;
}

.model-picker-option__swatch {
  width: 12px;
  height: 12px;
  border-radius: 999px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.55);
}

.model-picker-option__name {
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.benchmark-modal__search {
  padding: 16px 20px 12px;
  display: grid;
  gap: 7px;
}

.benchmark-modal__search span {
  color: #344054;
  font-size: 12px;
  font-weight: 850;
}

.benchmark-modal__search input {
  width: 100%;
  min-height: 42px;
  padding: 0 12px;
  border: 1px solid #cfd7e3;
  border-radius: 6px;
  color: #172033;
  font-size: 14px;
}

.benchmark-modal__search input:focus {
  border-color: #147a3b;
  outline: 3px solid rgba(20, 122, 59, 0.16);
}

.benchmark-picker-list {
  padding: 0 20px 16px;
  display: grid;
  gap: 8px;
}

.benchmark-picker-option {
  padding: 12px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr);
  align-items: start;
  gap: 10px;
  cursor: pointer;
  background: #ffffff;
  transition: background 0.16s ease, border-color 0.16s ease, box-shadow 0.16s ease;
}

.benchmark-picker-option:hover,
.benchmark-picker-option:focus-within {
  border-color: #92c6a5;
  background: #ffffff;
}

.benchmark-picker-option.is-selected {
  border-color: #147a3b;
  background: #ffffff;
  box-shadow: inset 0 0 0 1px rgba(20, 122, 59, 0.08);
}

.benchmark-picker-option__body {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.benchmark-picker-option__body strong {
  color: #172033;
  font-size: 14px;
}

.benchmark-picker-option__body small {
  color: #147a3b;
  font-size: 12px;
  font-weight: 850;
}

.benchmark-picker-option__body em {
  color: #667085;
  font-size: 12px;
  line-height: 1.5;
  font-style: normal;
}

.benchmark-picker-empty {
  margin: 0 20px 16px;
  padding: 24px 16px;
  border: 1px dashed #cfd7e3;
  border-radius: 8px;
  text-align: center;
}

.benchmark-picker-empty strong {
  color: #172033;
}

.benchmark-picker-empty p {
  margin: 6px 0 0;
  color: #667085;
}

.benchmark-modal__actions {
  padding: 14px 20px 18px;
  border-top: 1px solid #e4e8ef;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.benchmark-modal__actions button {
  padding: 0 14px;
}

.benchmark-modal__actions button:last-child {
  color: #ffffff;
  border-color: #147a3b;
  background: #147a3b;
}

.chart-grid,
.detail-grid,
.key-grid,
.map-grid,
.catalog-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.chart-card,
.detail-card,
.key-card,
.map-card,
.benchmark-card {
  padding: 14px 16px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #fbfcfe;
}

.chart-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.chart-card__header {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: flex-start;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e8ef;
}

.chart-card__header h3,
.detail-card h3,
.benchmark-card h3,
.key-card strong,
.map-card h3 {
  display: block;
  margin: 0 0 8px;
  color: #172033;
  font-size: 15px;
}

.chart-card__header h3 {
  margin-bottom: 0;
}

.chart-card__header span {
  flex: 0 0 auto;
  color: #147a3b;
  font-size: 11px;
  font-weight: 850;
  text-align: right;
}

.chart-row {
  display: grid;
  gap: 6px;
}

.chart-row__label {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: #172033;
  font-size: 12px;
}

.chart-row__label strong {
  min-width: 0;
  overflow-wrap: anywhere;
}

.chart-row__label span {
  flex: 0 0 auto;
  color: #166534;
  font-weight: 850;
}

.chart-row__track {
  height: 10px;
  overflow: hidden;
  border-radius: 999px;
  background: #e6eaf0;
}

.chart-row__bar {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #147a3b, #28a865);
}

.detail-card h3 {
  margin-bottom: 8px;
}

.detail-card p {
  margin: 0;
  font-size: 13px;
}

.benchmark-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.benchmark-card h3 {
  margin-bottom: 0;
}

.benchmark-card p {
  margin: 0;
  color: #344054;
  font-size: 13px;
  line-height: 1.65;
}

.benchmark-card span {
  width: fit-content;
  padding: 4px 8px;
  border-radius: 999px;
  color: #166534;
  background: #e8f5ed;
  font-size: 11px;
  font-weight: 850;
}

.detail-link-groups {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 16px;
}

.category-guide-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.category-guide-card {
  min-width: 0;
  padding: 14px 16px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #fbfcfe;
}

.category-guide-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e8ef;
}

.category-guide-card__head h3 {
  margin: 0;
  color: #172033;
  font-size: 15px;
  line-height: 1.35;
}

.category-guide-card__head span {
  flex: 0 0 auto;
  color: #147a3b;
  font-size: 12px;
  font-weight: 850;
}

.category-guide-card p {
  margin: 12px 0;
  color: #344054;
  font-size: 13px;
  line-height: 1.7;
}

.category-guide-card dl {
  margin: 0;
  display: grid;
  gap: 8px;
}

.category-guide-card dl div {
  display: grid;
  gap: 3px;
}

.category-guide-card dt {
  color: #667085;
  font-size: 11px;
  font-weight: 850;
}

.category-guide-card dd {
  margin: 0;
  color: #344054;
  font-size: 12px;
  line-height: 1.55;
}

.category-guide-card ul {
  margin: 12px 0 0;
  padding-left: 18px;
  color: #344054;
  font-size: 13px;
  line-height: 1.7;
}

.category-guide-card a {
  color: #166534;
  font-weight: 800;
  text-decoration: none;
}

.category-guide-card a:hover,
.category-guide-card a:focus-visible {
  text-decoration: underline;
  outline: none;
}

.detail-link-group {
  padding: 14px 16px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #fbfcfe;
}

.detail-link-group h3 {
  margin: 0 0 10px;
  color: #172033;
  font-size: 15px;
}

.detail-links {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.detail-links a {
  min-width: 0;
  padding: 9px 10px;
  border: 1px solid #e4e8ef;
  border-radius: 7px;
  color: #172033;
  background: #ffffff;
  text-decoration: none;
}

.detail-links a:hover,
.detail-links a:focus-visible {
  border-color: #92c6a5;
  color: #166534;
  outline: none;
}

.detail-links strong,
.detail-links span {
  display: block;
  overflow-wrap: anywhere;
}

.detail-links strong {
  font-size: 13px;
}

.detail-links span {
  margin-top: 3px;
  color: #667085;
  font-size: 11px;
  font-weight: 700;
}

.key-card p,
.map-card p {
  margin: 0;
  font-size: 13px;
}

.note-box {
  margin: 16px 0 0;
  padding: 14px 16px;
  border: 1px solid #bfd8ca;
  border-left: 4px solid #16a34a;
  border-radius: 8px;
  background: #f1fbf5;
}

.note-box strong {
  display: block;
  margin-bottom: 5px;
  color: #14532d;
  font-size: 13px;
}

.note-box p {
  margin: 0;
  color: #2f4f3a;
  font-size: 13px;
}

.table-scroll {
  width: 100%;
  max-width: 100%;
  overflow-x: visible;
}

.benchmark-table {
  width: 100%;
  margin: 14px 0 0;
  table-layout: fixed;
  border-collapse: collapse;
  border: 1px solid #d9dee7;
  font-size: 13px;
}

.benchmark-table th,
.benchmark-table td {
  padding: 11px 12px;
  border: 1px solid #d9dee7;
  vertical-align: top;
  text-align: left;
  line-height: 1.6;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.benchmark-table th {
  color: #172033;
  background: #f1f5f9;
  font-weight: 850;
}

.benchmark-table td:first-child,
.benchmark-table td:nth-child(2) {
  color: #172033;
  font-weight: 750;
}

.model-points,
.risk-list {
  margin: 0;
  padding-left: 20px;
  color: #344054;
  font-size: 14px;
  line-height: 1.8;
}

.source-list {
  margin: 0;
  padding-left: 0;
  list-style: none;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  color: #344054;
  font-size: 14px;
  line-height: 1.8;
}

.source-list li {
  min-width: 0;
}

.model-points {
  margin-top: 14px;
  padding: 12px 16px 12px 34px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #ffffff;
}

.source-list a {
  display: inline;
  max-width: 100%;
  color: #166534;
  font-weight: 750;
  text-decoration: none;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.source-list a:hover,
.source-list a:focus-visible {
  text-decoration: underline;
  outline: none;
}

.benchmark-infobox {
  padding: 16px;
}

.benchmark-infobox dl {
  margin: 12px 0 0;
}

.benchmark-infobox dl div {
  padding: 10px 0;
  border-top: 1px solid #e4e8ef;
}

.benchmark-infobox dt {
  color: #667085;
  font-size: 12px;
  font-weight: 750;
}

.benchmark-infobox dd {
  margin: 4px 0 0;
  color: #172033;
  font-size: 13px;
  line-height: 1.5;
  font-weight: 800;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.infobox-link {
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  margin-top: 12px;
  padding: 0 12px;
  border-radius: 6px;
  color: #ffffff;
  background: #147a3b;
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;
}

.infobox-link:hover,
.infobox-link:focus-visible {
  background: #166534;
  outline: none;
}

@media (max-width: 1080px) {
  .benchmark-page {
    grid-template-columns: 1fr;
  }
  .benchmark-toc,
  .benchmark-infobox {
    position: static;
  }
  .benchmark-toc > ol {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .benchmark-topbar__inner,
  .benchmark-page {
    width: min(100% - 28px, 1240px);
  }
  .benchmark-topbar__inner {
    min-height: auto;
    padding: 14px 0;
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }
  .benchmark-nav {
    width: 100%;
    overflow-x: visible;
  }
  .benchmark-nav a {
    flex: 1 1 auto;
    justify-content: center;
    text-align: center;
    white-space: normal;
  }
  .benchmark-title,
  .benchmark-section {
    padding: 22px 18px;
  }
  .benchmark-title h1 {
    font-size: 30px;
  }
  .chart-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .chart-filter-button {
    width: 100%;
  }
  .chart-panel {
    height: 430px;
    padding: 12px;
  }
  .benchmark-modal-shell {
    padding: 12px;
    align-items: flex-end;
  }
  .benchmark-modal {
    max-height: calc(100vh - 24px);
  }
  .benchmark-modal__head,
  .model-picker-panel__head,
  .benchmark-modal__actions {
    flex-direction: column;
  }
  .model-picker-list {
    grid-template-columns: 1fr;
  }
  .modal-close,
  .benchmark-modal__actions button {
    width: 100%;
  }
  .chart-grid,
  .detail-grid,
  .key-grid,
  .map-grid,
  .category-guide-grid,
  .catalog-grid,
  .benchmark-rule-grid,
  .benchmark-flow,
  .source-list,
  .detail-link-groups,
  .detail-links,
  .benchmark-toc > ol {
    grid-template-columns: 1fr;
  }
  .chart-card__header {
    flex-direction: column;
  }
  .chart-card__header span {
    text-align: left;
  }
  .score-table,
  .score-table thead,
  .score-table tbody,
  .score-table tr,
  .score-table th,
  .score-table td {
    display: block;
  }
  .score-table {
    border-collapse: separate;
    border-spacing: 0;
  }
  .score-table thead {
    display: none;
  }
  .score-table tbody {
    display: grid;
    gap: 10px;
    padding: 10px;
  }
  .score-table tbody tr {
    border: 1px solid #d9dee7;
    border-radius: 8px;
    overflow: hidden;
    background: #ffffff;
  }
  .score-table tbody th,
  .score-table tbody td {
    width: 100%;
    border: 0;
    border-bottom: 1px solid #e4e8ef;
  }
  .score-table tbody th {
    background: #f1f5f9;
  }
  .score-table tbody td {
    display: grid;
    gap: 4px;
  }
  .score-table tbody td:last-child {
    border-bottom: 0;
  }
  .score-table tbody td::before {
    content: attr(data-label);
    color: #147a3b;
    font-size: 11px;
    font-weight: 850;
  }
}`],
})
export class PageBenchmarksLlmComponent implements OnInit, AfterViewInit, OnDestroy {
    public readonly tocBenchmarkCount = BENCHMARK_TOC_ITEMS.length;
    public readonly categoryGuides: BenchmarkCategoryGuideCard[] = BENCHMARK_CATEGORY_GUIDES.map((guide) => {
        const items = BENCHMARK_TOC_ITEMS.filter((item) => item.categoryId === guide.id);
        return {
            ...guide,
            count: items.length,
            featuredItems: items.slice(0, 3),
        };
    });
    public readonly detailGroups = BENCHMARK_CATEGORIES
        .map((category) => ({
            ...category,
            items: BENCHMARK_TOC_ITEMS.filter((item) => item.categoryId === category.id),
        }))
        .filter((group) => group.items.length > 0);
    public readonly benchmarkModels = BENCHMARK_MODELS;
    public readonly benchmarkScoreSets = BENCHMARK_SCORE_SETS;
    public selectedModelIds = [...DEFAULT_MODEL_IDS];
    public selectedBenchmarkIds = [...DEFAULT_BENCHMARK_IDS];
    public benchmarkSearchQuery = '';
    public isBenchmarkModalOpen = false;
    private benchmarkChart?: Chart<'bar', (number | null)[], string>;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public ngAfterViewInit() {
        this.queueBenchmarkChartRender();
    }

    public ngOnDestroy() {
        this.benchmarkChart?.destroy();
    }

    public scrollToSection(event: Event, sectionId: string) {
        event.preventDefault();
        document.getElementById(sectionId)?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }

    public get selectedBenchmarkSets() {
        return this.benchmarkScoreSets.filter((benchmark) => this.selectedBenchmarkIds.includes(benchmark.id));
    }

    public get selectedBenchmarkModels() {
        return this.benchmarkModels.filter((model) => this.selectedModelIds.includes(model.id));
    }

    public get hasBenchmarkChartData() {
        return this.selectedBenchmarkSets.length > 0 && this.selectedBenchmarkModels.length > 0;
    }

    public get filteredBenchmarkSets() {
        const query = this.normalizeSearch(this.benchmarkSearchQuery);
        if (!query) return this.benchmarkScoreSets;
        return this.benchmarkScoreSets.filter((benchmark) => {
            return this.normalizeSearch(`${benchmark.name} ${benchmark.category} ${benchmark.description}`).includes(query);
        });
    }

    public get selectedBenchmarkSummary() {
        return this.summarizeNames(
            this.selectedBenchmarkSets.map((benchmark) => benchmark.name),
            '선택된 벤치마크가 없습니다.',
        );
    }

    public get selectedModelSummary() {
        return this.summarizeNames(
            this.selectedBenchmarkModels.map((model) => model.name),
            '선택된 모델이 없습니다.',
        );
    }

    public async openBenchmarkModal() {
        this.isBenchmarkModalOpen = true;
        await this.service.render();
    }

    public async closeBenchmarkModal() {
        this.isBenchmarkModalOpen = false;
        await this.service.render();
    }

    public async onBenchmarkSearchInput(event: Event) {
        this.benchmarkSearchQuery = (event.target as HTMLInputElement).value;
        await this.service.render();
    }

    public async toggleModelSelection(modelId: string) {
        if (this.selectedModelIds.includes(modelId)) {
            this.selectedModelIds = this.selectedModelIds.filter((id) => id !== modelId);
        } else {
            this.selectedModelIds = [...this.selectedModelIds, modelId];
        }

        await this.service.render();
        this.queueBenchmarkChartRender();
    }

    public async toggleBenchmarkSelection(benchmarkId: string) {
        if (this.selectedBenchmarkIds.includes(benchmarkId)) {
            this.selectedBenchmarkIds = this.selectedBenchmarkIds.filter((id) => id !== benchmarkId);
        } else {
            this.selectedBenchmarkIds = [...this.selectedBenchmarkIds, benchmarkId];
        }

        await this.service.render();
        this.queueBenchmarkChartRender();
    }

    public async resetChartSelection() {
        this.selectedModelIds = [...DEFAULT_MODEL_IDS];
        this.selectedBenchmarkIds = [...DEFAULT_BENCHMARK_IDS];
        this.benchmarkSearchQuery = '';

        await this.service.render();
        this.queueBenchmarkChartRender();
    }

    public isModelSelected(modelId: string) {
        return this.selectedModelIds.includes(modelId);
    }

    public isBenchmarkSelected(benchmarkId: string) {
        return this.selectedBenchmarkIds.includes(benchmarkId);
    }

    public benchmarkScoreLabel(benchmark: BenchmarkScoreSet, modelId: string) {
        const score = benchmark.scores[modelId];
        return typeof score === 'number' ? `${score.toFixed(1)}${benchmark.unit}` : '-';
    }

    public trackByScoreSet(_: number, benchmark: BenchmarkScoreSet) {
        return benchmark.id;
    }

    public trackByModel(_: number, model: BenchmarkModel) {
        return model.id;
    }

    public trackByGroup(_: number, group: { id: string }) {
        return group.id;
    }

    public trackByCategoryGuide(_: number, guide: BenchmarkCategoryGuideCard) {
        return guide.id;
    }

    public trackByBenchmark(_: number, benchmark: BenchmarkDetail) {
        return benchmark.slug;
    }

    private renderBenchmarkChart() {
        const selectedBenchmarks = this.selectedBenchmarkSets;
        const selectedModels = this.selectedBenchmarkModels;
        if (!selectedBenchmarks.length || !selectedModels.length) {
            this.benchmarkChart?.destroy();
            this.benchmarkChart = undefined;
            return;
        }

        const canvas = document.getElementById('benchmark-comparison-chart') as HTMLCanvasElement | null;
        if (!canvas) return;

        const labels = selectedBenchmarks.map((benchmark) => benchmark.name);
        const datasets = selectedModels.map((model) => ({
            label: model.name,
            data: selectedBenchmarks.map((benchmark) => benchmark.scores[model.id] ?? null),
            borderColor: model.color,
            backgroundColor: model.color,
            borderWidth: 0,
            borderRadius: 6,
            barPercentage: 0.82,
            categoryPercentage: 0.86,
            maxBarThickness: 18,
        }));

        if (this.benchmarkChart) {
            this.benchmarkChart.data.labels = labels;
            this.benchmarkChart.data.datasets = datasets;
            this.benchmarkChart.update();
            return;
        }

        const config: ChartConfiguration<'bar', (number | null)[], string> = {
            type: 'bar',
            data: { labels, datasets },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        top: 2,
                    },
                },
                interaction: {
                    mode: 'nearest',
                    intersect: false,
                },
                plugins: {
                    legend: {
                        position: 'top',
                        align: 'start',
                        labels: {
                            color: '#344054',
                            usePointStyle: true,
                            pointStyle: 'circle',
                            boxWidth: 7,
                            boxHeight: 7,
                            padding: 10,
                            font: {
                                size: 10,
                                weight: '700',
                            },
                        },
                    },
                    tooltip: {
                        callbacks: {
                            label: (context) => `${context.dataset.label}: ${context.parsed.y?.toFixed(1)}%`,
                        },
                    },
                },
                scales: {
                    x: {
                        grid: { display: false },
                        ticks: {
                            color: '#475467',
                            maxRotation: 28,
                            autoSkip: false,
                        },
                    },
                    y: {
                        beginAtZero: true,
                        suggestedMax: 100,
                        ticks: {
                            color: '#475467',
                            callback: (value) => `${value}%`,
                        },
                        grid: {
                            color: '#eef2f7',
                        },
                    },
                },
            },
        };

        this.benchmarkChart = new Chart(canvas, config);
    }

    private queueBenchmarkChartRender() {
        window.setTimeout(() => this.renderBenchmarkChart());
    }

    private normalizeSearch(value: string) {
        return value.trim().toLowerCase();
    }

    private summarizeNames(names: string[], emptyText: string) {
        if (!names.length) return emptyText;
        const visibleNames = names.slice(0, 4).join(', ');
        return names.length > 4 ? `${visibleNames} 외 ${names.length - 4}개` : visibleNames;
    }
}

export default PageBenchmarksLlmComponent;